// import AddExtraction from "./components/extract/AddExtraction";
// import ExtractRuns from "./components/extract/ExtractRuns";
// import ExtractRunViewer from "./components/extract/ExtractRunViewer";
// import AppList from "./pages/apps/AppsList";
// import ViewAppInfo from "./pages/apps/ViewAppInfo";
import ChooseTenant from "./pages/auth/ChooseTenant";
import ForgotPassword from "./pages/auth/ForgotPassword";
import Login from "./pages/auth/Login";
import OAuth2RedirectHandler from "./pages/auth/OAuth2RedirectHandler";
import AppsOauth2Redirect from "./pages/apps/AppsOauth2Redirect";
import OTPVerification from "./pages/auth/OTPVerification";
import CloudList from "./pages/cloud/CloudList";
import ClusterList from "./pages/cloud/ClusterList";
// import ExtractMain from "./pages/extract/ExtractMain";
import FileEditor from "./pages/file/FileEditor";
import PromptList from "./pages/prompt/PromptList";
import Settings from "./pages/settings/Settings";
import Stack from "./pages/stack/stack"
import StorageMain from "./pages/storage/StorageMain";
import StorageView from "./pages/storage/StorageView";
import { Navigate } from "react-router-dom";
import UpdatePassword from "./pages/usermanagement/UpdatePassword";
import UserList from "./pages/usermanagement/UserList";
import { isPocTenant } from "./utils/premiumAccess";
import UsageBilling from "./pages/billing/UsageBilling";
import AgentApps from "./pages/agentapps/AgentApps";
import ApprovalRedirectHandler from "./pages/auth/ApprovalRedirectHandler";
import Marketplace from "./pages/auth/Marketplace";

// icons
import { FaRegUser, FaDollarSign } from "react-icons/fa";
import { GrStorage } from "react-icons/gr";
import { IoIosCloudOutline } from "react-icons/io";
import { LuShipWheel } from "react-icons/lu";
import { TbPrompt } from "react-icons/tb";
// import { FaClipboardCheck } from "react-icons/fa";
import Evaluation from "./pages/Evaluation";


function UserManagementRoute() {
    if (isPocTenant()) {
        return <Navigate to="/settings?view=user-management" replace />;
    }
    return <UserList />;
}

let routes = [
    {
        path: "login",
        name: "Auth",
        icon: "fa-solid fa-table",
        element: <Login />,
        layout: "/auth",
        module: "Auth",
        display: false
    },
    {
        path: "marketplace",
        name: "Marketplace",
        icon: "fa-solid fa-table",
        element: <Marketplace />,
        layout: "/auth",
        module: "Auth",
        display: false
    },
    {
        path: "update-password",
        name: "Auth",
        icon: "fa-solid fa-table",
        element: <UpdatePassword />,
        layout: "/auth",
        module: "Auth",
        display: false
    },
    {
        path: "tenants",
        name: "Choose Tenant",
        icon: "fa-solid fa-table",
        element: <ChooseTenant />,
        layout: "/auth",
        module: "Auth",
        display: false
    },
    {
        path: "oauth2-redirect",
        name: "Auth Verification",
        icon: "fa-solid fa-table",
        element: <OAuth2RedirectHandler />,
        layout: "/auth",
        module: "Auth",
        display: false
    },
    {
        path: "approval",
        name: "Approval Verification",
        icon: "fa-solid fa-table",
        element: <ApprovalRedirectHandler />,
        layout: "/auth",
        module: "Auth",
        display: false
    },
    {
        path: "forgotpassword",
        name: "Auth",
        icon: "fa-solid fa-table",
        element: <ForgotPassword />,
        layout: "/auth",
        module: "Auth",
        display: false
    },
    {
        path: "verify-otp",
        name: "OTP Verification",
        icon: "fa-solid fa-table",
        element: <OTPVerification />,
        layout: "/auth",
        module: "Auth",
        display: false
    },
    // {
    //     path: "apps",
    //     name: "Apps",
    //     icon: <IoMdApps />,
    //     element: <AppList />,
    //     layout: "/",
    //     module: "Apps",
    //     display: true
    // },
    // {
    //     path: "extract",
    //     name: "Extract",
    //     icon: <LiaFileExportSolid />,
    //     element: <ExtractMain />,
    //     layout: "/",
    //     module: "Extract",
    //     display: true,
    // },
    // {
    //     path: "extract/create-extraction",
    //     name: "Create-Extraction",
    //     element: <AddExtraction />,
    //     layout: "/",
    //     module: "Create-Extraction",
    //     display: false,
    // },
    // {
    //     path: "extract/runs",
    //     name: "Extract-Runs",
    //     element: <ExtractRuns />,
    //     layout: "/",
    //     module: "ExtractRuns",
    //     display: false,
    // },
    // {
    //     path: "extract-view",
    //     name: "Extract-View",
    //     element: <ExtractRunViewer />,
    //     layout: "/",
    //     module: "Extract-Run",
    //     display: false,
    // },
    {
        path: "prompts",
        name: "Prompt",
        icon: <TbPrompt />,
        element: <PromptList />,
        layout: "/",
        module: "Prompt",
        display: true
    },
    {
        path: "storage",
        name: "Storage",
        icon: <GrStorage />,
        element: <StorageMain />,
        layout: "/",
        module: "Storage",
        display: true
    },
    {
        path: "storageView",
        name: "StorageView",
        element: <StorageView />,
        layout: "/",
        module: "StorageView",
        display: false
    },
    {
        path: "usermanagement",
        name: "User Management",
        icon: <FaRegUser />,
        element: <UserManagementRoute />,
        layout: "/",
        module: "UserList",
        display: true
    },
    {
        path: "settings",
        name: "Settings",
        element: <Settings />,
        layout: "/",
        module: "Settings",
        display: true
    },
    {
        path: "stack",
        name: "Stack",
        element: <Stack />,
        layout: "/",
        module: "Stack",
        display: true
    },
    
    {
        path: "agentapps",
        name: "Agent Apps",
        element: <AgentApps />,
        layout: "/",
        module: "AgentApps",
        display: false
    },
    {
        path: "apps/oauth2-redirect",
        name: "Apps OAuth2 Redirect",
        element: <AppsOauth2Redirect />,
        layout: "/",
        module: "Apps",
        display: false
    },
    {
        path: "billing",
        name: "Usage Billing",
        icon: <FaDollarSign />,
        element: <UsageBilling />,
        layout: "/",
        module: "Usage Billing",
        display: true
    },
    {
        path: "cloud",
        name: "Cloud",
        icon: <IoIosCloudOutline />,
        element: <CloudList />,
        layout: "/",
        module: "CloudList",
        display: true,
    },
    {
        path: "clusters",
        name: "Cluster",
        icon: <LuShipWheel />,
        element: <ClusterList />,
        layout: "/",
        module: "ClusterList",
        display: true,
    },
    // {
    //     path: "apps/view",
    //     name: "View App",
    //     element: <ViewAppInfo />,
    //     layout: "/",
    //     module: "Apps",
    //     display: false
    // },
    // {
    //     path: "apps/create",
    //     name: "View App",
    //     element: <ViewAppInfo />,
    //     layout: "/",
    //     module: "Apps",
    //     display: false
    // },
    {
        path: "evaluation",
        name: "Evaluation",
        element: <Evaluation />,
        layout: "/",
        module: "Apps",
        display: true
    },
    // {
    //     path: "apps/deploy",
    //     name: "View App",
    //     element: <ViewAppInfo />,
    //     layout: "/",
    //     module: "Apps",
    //     display: false
    // },
  
    {
        path: "file/editor",
        name: "File Editor",
        element: <FileEditor />,
        layout: "/",
        module: "File Editor",
        display: false
    }
]


export default routes;